import script from "./VFileList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VFileList.vue?vue&type=script&setup=true&lang=ts"

import "./VFileList.vue?vue&type=style&index=0&id=6e54fcd1&lang=scss"

const __exports__ = script;

export default __exports__